import { render, staticRenderFns } from "./AdoptionMetrics.vue?vue&type=template&id=2a270dda&"
import script from "./AdoptionMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./AdoptionMetrics.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports